import React, { useState } from 'react'
import Navbar from '../Components/Navbar'
import Table from '../Components/Table'
import Footer from '../Components/Footer'
import StatusIndicator from '../Components/StatusIndicator'
import ResultTable from '../Components/ResultTable'

import "../css/styles.css"
import Headerpage from '../Components/Headerpage'
import Logo from '../Components/Logo'


const HomePage = () => {
    let minOffset = 0, maxOffset = 1;
    let thisYear = (new Date()).getFullYear();
    let allYears = [];
    for (let x = minOffset; x <= maxOffset; x++) {
        allYears.push(thisYear - x)
    }
    const months = [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤษจิกายน",
        "ธันวาคม"
    ];


    const monthNow = new Date().getMonth();
    const yaerNow = new Date().getFullYear();
    const [month, setMonth] = useState(monthNow)
    const [year, setYear] = useState(yaerNow)
    const parsemonth = parseInt(month)
    const realmonth = parsemonth + 1;

    var countdate = new Date();
    countdate = new Date(); countdate.setFullYear(year, realmonth, 0);
    const date = `${countdate.getDate()}`;
    const numberDate = parseInt(date)

    return (
        <div>
            <Navbar />
            <Logo />
            <Headerpage />
            <div id="layoutSidenav">
                <div id="layoutSidenav_content">
                    <main>
                        <div className="container-fluid px-4">
                            <div className='row'>
                                <div className='col'>
                                    <h1 className="mt-4">Service Performance Report</h1>
                                    <ol className="breadcrumb mb-4">
                                        <li className="breadcrumb-item active">uptime ของระบบในแต่ละวัน</li>
                                    </ol>
                                </div>
                                <div className='col'>
                                    <div className='d-flex justify-align-content-end' style={{ paddingTop: "2rem", paddingLeft: "5rem" }}>
                                        <select className="form-select" aria-label=""
                                            onChange={e => setMonth(e.target.value)}
                                            defaultValue={month}
                                        >
                                            {
                                                months.map((x, key) => { return (<option key={key} value={key}>{x}</option>) })
                                            }
                                        </select>
                                        &emsp;
                                        <select className="form-select" aria-label=""
                                            onChange={e => setYear(e.target.value)}
                                            defaultValue={year}
                                        >
                                            {
                                                allYears.map((x, key) => { return (<option key={key} value={x}>{x + 543}</option>) })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="card mb-4">
                                <div className="card-header">
                                    <i className="fas fa-table me-1" /> &emsp;
                                    เดือน {months[parsemonth]} พ.ศ.{parseInt(year)+543}
                                </div>
                                <div className="card-body">
                                    <Table numberDate={numberDate} datetime={year + "-" + realmonth} />
                                    {/* <Test numberDate={numberDate} datetime={year + "-" + realmonth} /> */}
                                </div>
                            </div>
                            <div className="card mb-4 border-0">
                                <StatusIndicator className={"indicator success"} indicator={"มากกว่าหรือเท่ากับ 98.5% บริการปรกติ"} />
                                <StatusIndicator className={"indicator warning"} indicator={"มากกว่า 90% น้อยกว่า 98.5% มีเหตุการณ์ผิดปรกติ"} />
                                <StatusIndicator className={"indicator danger"} indicator={"น้อยกว่า 90% บริการขัดข้อง"} />
                            </div>
                            <div className="card mb-4 border-0">
                                <p>การให้บริการมีการวัดผลจากความสามารถในการใช้บริการของผู้ใช้บริการได้อย่างสะดวกไม่เกิดปัญหาหรือข้อติดขัดในการใช้บริการไม่น้อยไปกว่า 99.5% ( ลิงก์อ้างอิงเอกสาร <a href='https://cloud.google.com/compute/sla' target={'_blank'} rel="noreferrer">https://cloud.google.com/compute/sla</a> )</p>
                            </div>
                            <div className='card mb-4'>
                                <ResultTable lastday={numberDate} />
                            </div>
                        </div>
                    </main>

                    <Footer />
                </div>
            </div >
        </div >
    )
}

export default HomePage